import React, {FC, useEffect} from 'react';

import {PlaceholderContainer, StatusIllustrationContext} from '@yandex-data-ui/cloud-components';
import * as Metrika from 'ui/utils/metrika';
import {sendPageInfo} from 'ui/utils/postMessages';

import {cnError} from './Error.constants';
import {ErrorProps} from './Error.types';
import {useError} from './Error.utils';

import './Error.scss';

const {
    mobile,
    routes: {bucketUrl},
    iframe,
} = window.YC;

const Error: FC<ErrorProps> = ({error}) => {
    const errorProps = useError(error);

    useEffect(() => {
        if (iframe) {
            sendPageInfo('error-page-iframe');
        }
        Metrika.error();
    }, []);

    return (
        <div className={cnError()}>
            <StatusIllustrationContext.Provider
                value={{
                    version: 'v2',
                    bucketUrl,
                }}
            >
                <PlaceholderContainer
                    {...errorProps}
                    size={mobile ? 'm' : 'l'}
                    direction={mobile ? 'column' : 'row'}
                />
            </StatusIllustrationContext.Provider>
        </div>
    );
};

export default Error;
